import * as Yup from 'yup';

export const numberSeriesValidationSchema = Yup.object().shape({
    
});
